// Newest first. The first entry's version must equal package.json's version
// (enforced by tests/unit/release.test.js).
export default [
  {
    version: '1.3.2',
    date: '2026-09-28',
    title: 'Emails from Bhagavad Gita',
    notes: [
      'Sign-in codes now come from bhagavadgita@vibecod3.app, named Bhagavad Gita, so they are easy to spot in your inbox.',
    ],
  },
  {
    version: '1.3.1',
    date: '2026-09-28',
    title: 'What a lesson is',
    notes: [
      'The How it works guide now lists every lesson in an example chapter by name, with the verses it covers, so it is clear what a lesson is.',
      'Each chapter page says how its verses are split into lessons.',
    ],
  },
  {
    version: '1.3.0',
    date: '2026-09-28',
    title: 'Start with how it works',
    notes: [
      'A new How it works guide explains what the Gita is, how its chapters, lessons and verses fit together, what happens in a lesson, and where everything is. New learners see it first, and it is one tap away from Today, Journey, Explore and Settings.',
      'Your journey now starts at chapter 1. The four background lessons are optional reading and no longer count towards your progress.',
      'Updates reach the site faster: each change is tested in full once, before it is merged.',
    ],
  },
  {
    version: '1.2.0',
    date: '2026-09-28',
    title: 'Saved from the first lesson',
    notes: [
      'Starting the journey now asks you to sign in first, so your progress is saved from the very first lesson. You can still choose "Not now".',
      'Until you sign in, every finished lesson and the Today screen offer to save your progress, and signing in happens right there, without leaving the page.',
      'Sharing a link on WhatsApp and other apps now shows a large preview image with the full title and description. Shared verses, chapters, ideas and people show their own words.',
    ],
  },
  {
    version: '1.1.1',
    date: '2026-09-28',
    title: 'A deeper health check',
    notes: [
      'Every update now also checks that accounts and saved progress are reachable before it counts as live.',
    ],
  },
  {
    version: '1.1.0',
    date: '2026-09-28',
    title: 'Sign in with your email',
    notes: [
      'The app is now called Bhagavad Gita.',
      'Sign in with just your email. We send you a 6-digit code, so there is no password to remember, and the same code creates your account the first time.',
      'Everything you have done on a device comes with you when you sign in. After that, your progress, notes and settings sync to every device where you sign in.',
      'Passkeys are no longer used. If you signed in with one before, add your email in Settings to keep your account.',
      'After every page change, keyboard and screen reader focus now lands in the right place.',
    ],
  },
  {
    version: '1.0.1',
    date: '2026-09-28',
    title: 'A second, careful reading',
    notes: [
      'Every chapter was checked again, verse by verse, against the Sanskrit. More than fifty explanations, notes and translations are now more accurate.',
      'Where commentators disagree, the notes name a teacher only when the attribution is certain, and otherwise describe the school of thought.',
      'Sanskrit terms such as brahman are written the same way throughout.',
      'The tab bar and top bars are a little more solid, so text scrolling underneath never shows through.',
      'A tidier header on each verse page.',
    ],
  },
  {
    version: '1.0.0',
    date: '2026-09-28',
    title: 'The first edition',
    notes: [
      'All 700 verses in clear, modern English, each with a plain-English explanation, and the original Sanskrit one tap away.',
      '91 short lessons across the prologue and 18 chapters, each ending with a quick check and a moment to reflect.',
      'A journey map that turns from night to morning as you progress, with streaks and a verse for each day.',
      'Key ideas, a guide to who is who, search across everything, bookmarks and private notes.',
      'Passkey sign-in so your progress follows you to any device, with no password and no email.',
      'Works offline once loaded, in light and dark, at any text size.',
    ],
  },
];
